import content from '@/content/projects/0920-newsroom-podcast-links'

export default content



// WEBPACK FOOTER //
// ./src/content/index.js